import { useCallback, useEffect, useRef } from 'react';

const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

export default function useScrollTo() {
  const topRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<number | undefined>();
  const Anchor = useCallback(() => <div ref={topRef} />, []);

  const scrollTo = useCallback(
    ({ timeout = 500, ...options } = {}) =>
      (timeoutRef.current = window.setTimeout(
        () =>
          topRef.current?.scrollIntoView(
            isSmoothScrollSupported && {
              behavior: 'smooth',
              block: 'nearest',
              ...options,
            },
          ),
        timeout,
      )),

    [],
  );

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return [Anchor, scrollTo] as const;
}
